<template>
  <section>
    <div class="mb-4">
      <h3 class="text-base font-semibold">Date of visit</h3>
    </div>

    <div class="grid gap-2" :class="dateListClasses">
      <button
        v-for="item in dates"
        :key="item.value"
        :value="item.value"
        :title="item.label"
        :disabled="item.disabled"
        type="button"
        :class="dateButtonClasses(item)"
        @click.prevent="$emit('select-date', item.value)"
      >
        <span
          class="text-md lg:text-[20px] leading-none"
          v-text="item.day"
        ></span>
        <span class="mb-1 text-lg lg:text-[22px] font-medium leading-none flex gap-1">
          <span
              v-text="item.date"
          ></span>
          <span
              :class="{ 'line-through': item.disabled }"
              v-text="item.month"
          ></span>
        </span>
      </button>

      <button
        type="button"
        :class="moreDatesButtonClasses"
        @click="$emit('open-calendar')"
      >
        <span class="flex h-8 w-8 items-center justify-center rounded-full bg-dark text-[30px] leading-none text-light">+</span>
        <span class="text-center text-sm font-semibold leading-tight">More dates</span>
      </button>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  dates: {
    type: Array,
    default: () => [],
  },
  selectedDate: {
    type: String,
    default: '',
  },
  fullscreenActive: {
    type: Boolean,
    default: false,
  },
  cartLayout: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['select-date', 'open-calendar'])

const cardBackgroundClass = computed(() => (props.fullscreenActive ? 'bg-light' : 'bg-white'))
const dateListClasses = computed(() => (
  props.fullscreenActive
    ? 'grid-cols-3 lg:grid-cols-[repeat(6,minmax(0,1fr))]'
    : 'grid-cols-[repeat(4,minmax(0,1fr))]'
))
const moreDatesButtonClasses = computed(() => (
  props.fullscreenActive
    ? 'flex min-h-[130px] flex-col items-center justify-center gap-3 rounded-2xl bg-transparent text-dark transition hover:bg-light'
    : 'flex py-2 flex-col items-center justify-center gap-3 rounded-lg bg-transparent text-dark transition hover:bg-white'
))

const dateButtonClasses = (item) => {
  const base = props.fullscreenActive
    ? 'flex min-h-[130px] w-full flex-col items-center justify-center gap-1 rounded-2xl p-4 disabled:line-through disabled:opacity-30'
    : 'flex w-full flex-col items-center justify-center gap-1 rounded-lg p-2 py-4 disabled:line-through disabled:opacity-30'

  const state = props.selectedDate === item.value
    ? 'bg-dark text-light'
    : `${cardBackgroundClass.value} text-dark hover:bg-dark hover:text-light`

  return `${base} ${state}`
}
</script>
